import { TimeshiftStatus } from '@zattoo/zapi/lib/stream/enums';
export const getVodState = () => {
    return {
        canSeekForward: true,
        canSeekBackward: true,
        canPause: true,
    };
};
export const getReplayRecordingState = (watchResponse) => {
    return {
        canSeekForward: watchResponse?.stream.forward_seeking ?? false,
        canSeekBackward: true,
        canPause: true,
    };
};
export const getRegisteredTimeshiftState = (watchResponse) => {
    return {
        canSeekForward: watchResponse?.stream.forward_seeking ?? false,
        canSeekBackward: true,
        canPause: true,
    };
};
export const getLiveState = (watchResponse) => {
    if (watchResponse?.unregistered_timeshift === TimeshiftStatus.AVAILABLE) {
        const canPause = true;
        const canSeekBackward = watchResponse.stream.replay_seeking_allowed ?? false;
        // yes, it is weird to enable forward seeking based on this property. see:
        // https://zattoo2.atlassian.net/wiki/spaces/PLY/pages/5907415049/Timeshift+Live+Pause
        const canSeekForward = watchResponse.stream.replay_seeking_allowed ?? false;
        return {
            canSeekForward,
            canSeekBackward,
            canPause,
        };
    }
    if (watchResponse?.register_timeshift === TimeshiftStatus.AVAILABLE) {
        const canPause = true;
        const canSeekBackward = false;
        const canSeekForward = false;
        return {
            canSeekForward,
            canSeekBackward,
            canPause,
        };
    }
    return {
        canSeekForward: false,
        canSeekBackward: false,
        canPause: false,
    };
};
